import { TagProps } from '@superdispatch/ui';
import { OnboardingPacketStatus } from 'shared/modules/onboarding-packets/data/OnboardingPacketDTO';

interface OnboardingPacketStatusConfig {
  label: string;
  color: NonNullable<TagProps['color']>;
}

const ONBOARDING_PACKET_STATUS_CONFIG: Record<
  OnboardingPacketStatus,
  OnboardingPacketStatusConfig
> = {
  pending: { label: 'Not Submitted', color: 'yellow' },
  submitted: { label: 'Pending Review', color: 'purple' },
  accepted: { label: 'Accepted', color: 'green' },
  not_accepted: { label: 'Not Accepted', color: 'red' },
};

export function getOnboardingPacketStatusConfig(
  status: OnboardingPacketStatus,
): OnboardingPacketStatusConfig {
  return ONBOARDING_PACKET_STATUS_CONFIG[status];
}

export function getOnboardingPacketsPageTitle(
  status: OnboardingPacketStatus | undefined,
): string {
  return status ? getOnboardingPacketStatusConfig(status).label : 'All';
}
